module.exports = __webpack_public_path__ + "static/cosycolour4-0a5f811adeb7a7a1c209df9eccc5c343.png";